export default __webpack_public_path__ + "static/media/124.1762648f.jpg";